import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {LeadaComponentsModule} from 'shared/components/leada-components.module';

import {HistoryPage} from './components/history-page/history-page';
import {HistoryRepository} from './repositories/history.repository';
import {HistoryService} from './services/history.service';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    LeadaComponentsModule,
    RouterModule.forChild([
      { path: '', component: HistoryPage },
    ]),
],
  providers: [
    HistoryRepository,
    HistoryService,
  ],
  declarations: [
    HistoryPage,
  ],
  // entryComponents: [
  //   HistoryPage,
  // ],
})
export class HistoryModule { }
